module.exports = __webpack_public_path__ + "img/alg6.8b33998e.png";